import store from './index';
export const selectLang = () => store((state) => state.lang);
export const selectCountryCode = () => store((state) => state.countryCode);
export const selectCountryName = () => store((state) => state.countryName);
export const selectExchange = () => store((state) => state.exchange);
export const selectPriceMeasurement = () => store((state) => state.priceMeasurement);
export const selectSquareMeasurement = () => store((state) => state.squareMeasurement);
export const selectCountryCurrency = () => store((state) => state.currencyCode);
export default {
    setMeasurements: store.getState().setMeasurements,
    getExchange: store.getState().getExchange,
};
